import { InboxStackIcon } from '@heroicons/react/24/outline';
import { TableIconButton } from '@stereograph/teia-system-design/components/Table';
import { Tooltip } from '@stereograph/teia-system-design/components/Tooltip';
import { usePluginTranslation } from '@translation';
import { MouseEventHandler, useState } from 'react';
import { TeiaQuantityTakeoffSelection } from './TeiaQuantityTakeoffSelection';

export const TeiaQuantityTakeoffSelectionButton = () => {
  const { t } = usePluginTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const handleClick: MouseEventHandler<HTMLElement> = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <Tooltip title={t('quantity_takeoff_plugin.selection.tooltip')} placement="bottom">
        <TableIconButton
          onClick={handleClick}
          aria-label={t('quantity_takeoff_plugin.selection.label')}
          icon={InboxStackIcon}
        />
      </Tooltip>
      <TeiaQuantityTakeoffSelection anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
    </>
  );
};
